import { render } from "./ColorList.vue?vue&type=template&id=4c3c2f01&ts=true"
import script from "./ColorList.vue?vue&type=script&lang=ts"
export * from "./ColorList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__